import { DeliveryInfoActivator } from "./DeliveryInfoActivator";

(<any>window).di = DeliveryInfoActivator.show;